import React from 'react';
import * as localization from '@happylife-a/localization';
import webCore from '@happylife-a/web-core';
import appBranding from '@happylife-a/branding';
import { Box, Flex, Text } from '@chakra-ui/react';
import AddToCartButton from './AddToCartButton';

function ProductNameAndDetails({ selectable, productDetail, product, displayProductInfo }) {
  const isHiddenPrice = appBranding.tools.features.isEnabled('ProductPrice');
  const isEcommerceFlowDisabled = appBranding.tools.features.isEnabled('DisableECommerceFlow');
  const { locale } = webCore.contexts.useTranslation();
  const { discountedPrice, price } = webCore.hooks.useIncreasedPrices({
    productDetail: productDetail,
  });

  return (
    <>
      <Box height={7} mb={isHiddenPrice ? 2 : 0}>
        <Text variant={{ base: 'body-reg-lg', md: 'sub-head-reg' }} noOfLines={1}>
          <Text as="span" cursor="pointer" onClick={!selectable ? displayProductInfo : undefined}>
            {localization.localize(productDetail?.title, locale) ||
              localization.localize(product?.title, locale)}
          </Text>
        </Text>
      </Box>
      {!isHiddenPrice && (
        <Flex flexDir="row" alignItems="center" justifyContent="space-between">
          <Flex alignItems="center">
            <Text
              variant={{
                base: 'body-reg-sm-bold',
                sm: 'sub-head-bold',
                md: 'h3-bold',
              }}
            >
              {discountedPrice || price}
            </Text>
            {!!discountedPrice && (
              <Text
                variant={{
                  base: 'body-reg-sm',
                  sm: 'sub-head-bold',
                  md: 'sub-head-bold',
                }}
                ml={1}
                opacity={0.5}
                // textDecorationLine="line-through"
                position="relative"
              >
                {price}
                <Box
                  position="absolute"
                  top="50%"
                  left={0}
                  width="100%"
                  height="1px"
                  opacity={0.5}
                  backgroundColor="gray.800"
                />
              </Text>
            )}
          </Flex>
          {!isEcommerceFlowDisabled && <AddToCartButton productDetail={productDetail} />}
        </Flex>
      )}
    </>
  );
}

export default ProductNameAndDetails;
